var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 0V20H0V3.15789L3 0H24ZM3 3.15789H6V6.31579H3V3.15789ZM8 3.15789H11V6.31579H8V3.15789ZM16 3.15789H13V6.31579H16V3.15789ZM18 3.15789H21V6.31579H18V3.15789ZM3 8.42105H6V11.5789H3V8.42105ZM8 8.42105H11V11.5789H8V8.42105ZM16 8.42105H13V11.5789H16V8.42105ZM18 8.42105H21V11.5789H18V8.42105ZM6 13.6842H3V16.8421H6V13.6842ZM11 13.6842H8V16.8421H11V13.6842ZM13 13.6842H16V16.8421H13V13.6842ZM21 13.6842H18V16.8421H21V13.6842Z",
    fill: "#474747"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlate);
export default __webpack_public_path__ + "static/media/Plate.9ed968e80d343b719ba1cf2e908e6abd.svg";
export { ForwardRef as ReactComponent };